import React, { useState, useEffect, useCallback } from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import { MultiSelect } from 'react-multi-select-component';
import ErrorMessage from '../../../../ErrorMessage';
import GroupService from '../../../../../Services/UserGroup/GroupService';
import GroupSearchParams from '../../../../../Contents/Administration/UserGroups/GroupSearchParams';

const ActiveGroupMultiChoice = ({
  label = '',
  onChange = () => alert('ActiveGroupMultiChoice Onchange'),
  selected = [],
  fieldName = '',
}) => {
  const [loading, setLoading] = useState(true);
  const [itemList, setItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const populateListData = useCallback(() => {
    const groupSearchParams = new GroupSearchParams();
    groupSearchParams.IsActive = true;
    GroupService.GetAllItemsBySearching('Name', 'Asc', 1, 99_999, groupSearchParams, false)
      .then((result) => {
        const optValues = [];
        const selectedArr = [];
        result.data.forEach((group) => {
          if (!group.name) {
            return;
          }
          const newValue = {
            label: group.name + (group.groupId ? ` (${group.groupId})` : ''),
            value: group.groupId,
          };
          optValues.push(newValue);
          if (selected && selected.some((x) => x.toString() === group.groupId.toString())) {
            selectedArr.push(newValue);
          }
        });
        setItemList(optValues);
        setSelectedItems(selectedArr);
        setLoading(false);
      })
      .catch(() => {
        setItemList([]);
        ErrorMessage.SetErrorMessage('CMC61');
      });
  }, [selected]);

  useEffect(() => {
    populateListData();
  }, [populateListData]);

  const multiSelectOnChange = (selectedArr) => {
    setSelectedItems(selectedArr);
    onChange(selectedArr.map((i) => i.value.toString()));
  };

  return (
    <div className={'text-center arial w-100 text-center hover rounded arial m-1 p-1'}>
      {loading ? (
        <LoadingIcon
          loading={true}
          className='h6'
        />
      ) : (
        <MultiSelect
          options={itemList}
          value={selectedItems}
          onChange={multiSelectOnChange}
          labelledBy='Select'
        />
      )}
    </div>
  );
};

export default ActiveGroupMultiChoice;
